export enum PriorityFourActivityName {
  FocusBuildings = 'Focus Buildings',
  ProgramEnrichment = 'ISD/District Program Enhancements'
}
